import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading1,
  Image,
  JustifyContent,
  Space,
  TextAlign,
  useTheme,
} from '@gousto-internal/citrus-react'

import { LandingPageButton } from '../../../../components'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import { HERO_SECTION_COPY } from './config'
import { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import carouselimageDesktop from '../../../../sections/assets/carouselimage.jpg'
import carouselimageMobile from '../../../../sections/assets/carouselimage-mobile.jpg'

export function HeroSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  const { theme } = useTheme()

  return (
    <Box>
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        paddingH={[4, 8, 20]}
        paddingV={[8, 16]}
        paddingBottom={[12, 16]}
      >
        <Box maxWidth="512px">
          <Box paddingBottom={3}>
            <Heading1 textAlign={TextAlign.Center}>{HERO_SECTION_COPY.mainHeading}</Heading1>
          </Box>
          <Box paddingBottom={[4]} paddingRight={[null, 4]}>
            <Body2 size={4} textAlign={TextAlign.Center}>
              {HERO_SECTION_COPY.descriptionParagraph1}
            </Body2>
            <Space size={4} />
            <Body2 size={4} textAlign={TextAlign.Center}>
              {HERO_SECTION_COPY.descriptionParagraph2}
            </Body2>
          </Box>

          <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
            <LandingPageButton
              action={TrackingActions.CLICK_RECIPE_NAVIGATION}
              sectionName={FoodBoxPageSections.HERO_SECTION}
              target={TargetUri.MENU}
              startOnboarding={startOnboarding}
            >
              {HERO_SECTION_COPY.ctaButtonText}
            </LandingPageButton>
          </Box>
        </Box>
      </Box>
      <picture>
        <source
          srcSet={carouselimageMobile}
          media={`(max-width: ${theme.tokens.breakpoints[0]})`}
          type="image/jpeg"
        />
        <Image
          fit="cover"
          height={['120px', '141px', null, '160px']}
          alt={HERO_SECTION_COPY.imageAltText}
          src={carouselimageDesktop}
        />
      </picture>
    </Box>
  )
}
